import { useCallback } from 'react';
import { tokenService } from '../../../services/tokenService';
import { useStytch as useStytchApp } from '../providers/StytchContext';

/**
 * Unified sign-out using Stytch B2B SDK + platform token revoke.
 * - Attempts to revoke the Stytch member session via SDK (best-effort)
 * - Always revokes/clears platform tokens afterward
 */
export function useStytchLogout() {
  const { stytch } = useStytchApp();

  const signOut = useCallback(async () => {
    // 1) Try to end the Stytch B2B session via SDK
    try {
      if (stytch?.session?.revoke) {
        await stytch.session.revoke();
      }
    } catch {}

    // 2) Revoke platform refresh token and clear local state
    await tokenService.signOut();
  }, [stytch]);

  return { signOut };
}

export default useStytchLogout;
